import { getAchievement } from 'apis/scoringVoucherAPI';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalStore from 'stores/globalStore';

interface TokenParam {
  token: string;
}

const ScoringGetAchievementApi = () => {
  const { status, execute, value } = useAsync(getAchievement, false);
  const { session } = GlobalStore.useContainer();
  const navigate = useNavigate();

  React.useEffect(() => {
    execute(session);
  }, [execute, session]);

  const scoringGetAchievementApi = React.useCallback(
    (params: TokenParam) => {
      execute(params.token);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      // message.error(value.errorMessage);
      return;
    }

    // message.success("Load achievement success");
  }, [navigate, value]);

  return {
    isLoading: status === 'pending',
    scoringGetAchievementApi,
    achievement: value
  };
};

export default ScoringGetAchievementApi;
